import { createAction, props } from '@ngrx/store';
import { User } from '@/services/user-search.service';
import { CreateUserDto, UpdateUserDto, UsersPagination } from '../../services/users.service';

// Load Users
export const loadUsers = createAction(
  '[Admin Users] Load Users',
  props<{ page: number; limit: number; search?: string }>()
);

export const loadUsersSuccess = createAction(
  '[Admin Users] Load Users Success',
  props<{ pagination: UsersPagination;  totalItems: number }>()
);

export const loadUsersFailure = createAction(
  '[Admin Users] Load Users Failure',
  props<{ error: any }>()
);

// Load Single User
export const loadUser = createAction(
  '[Admin Users] Load User',
  props<{ userId: string }>()
);

export const loadUserSuccess = createAction(
  '[Admin Users] Load User Success',
  props<{ user: User }>()
);

export const loadUserFailure = createAction(
  '[Admin Users] Load User Failure',
  props<{ error: any }>()
);

// Create User
export const createUser = createAction(
  '[Admin Users] Create User',
  props<{ userData: CreateUserDto }>()
);

export const createUserSuccess = createAction(
  '[Admin Users] Create User Success',
  props<{ user: User }>()
);

export const createUserFailure = createAction(
  '[Admin Users] Create User Failure',
  props<{ error: any }>()
);

// Update User
export const updateUser = createAction(
  '[Admin Users] Update User',
  props<{ userId: string; updates: UpdateUserDto }>()
);

export const updateUserSuccess = createAction(
  '[Admin Users] Update User Success',
  props<{ user: User }>()
);

export const updateUserFailure = createAction(
  '[Admin Users] Update User Failure',
  props<{ error: any }>()
);

// Delete User
export const deleteUser = createAction(
  '[Admin Users] Delete User',
  props<{ userId: string }>()
);

export const deleteUserSuccess = createAction(
  '[Admin Users] Delete User Success',
  props<{ userId: string }>()
);

export const deleteUserFailure = createAction(
  '[Admin Users] Delete User Failure',
  props<{ error: any }>()
);

// Clear User State
export const clearUserState = createAction('[Admin Users] Clear User State');
